import { toast } from "react-toastify";
import axiosPublic from "../../api/axiosConfig";
import { useState } from "react";
import { set } from "date-fns";

const DjForgotPassword = () => {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await axiosPublic.post("/auth/forgot-password", {
        email,
      });
      toast.success("Password reset link sent to your email");
      setEmail("");
    } catch (err) {
      if (err.response?.status === 400) {
        toast.error("Email not found");
      } else {
        toast.error("Server error, try later");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col items-center justify-center h-screen bg-notificationList p-4">
      <h2 className="text-2xl font-bold text-white mb-6">Forgot Password</h2>
      <form
        onSubmit={handleSubmit}
        className="w-full max-w-sm bg-white p-6 rounded-lg shadow-md"
      >
        <input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="w-full mb-4 p-3 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        <button
          type="submit"
          disabled={loading}
          className={`w-full p-3 rounded text-white transition ${
            loading
              ? "bg-gray-400 cursor-not-allowed"
              : "bg-blue-600 hover:bg-blue-700"
          }`}
        >
          {loading ? "Sending..." : "Send Reset Link"}
        </button>
      </form>
    </div>
  );
};

export default DjForgotPassword;
